<div class="c-hero">
  <img src="{{info.image}}" alt="{{info.alt}}">
</div>